import React from 'react';
import LegalPage from '../components/LegalPage';

const PrivacyPolicy = () => (
  <LegalPage
    testId="page-privacy"
    metaTitle="Política de Privacidad | VIDAT"
    title="Política de Privacidad"
    subtitle="Información sobre el tratamiento de datos personales en la web de VIDAT."
    sections={[
      {
        title: 'Responsable del tratamiento',
        body: [
          'El responsable del tratamiento de los datos personales recogidos a través de esta web es:',
          { type: 'block', lines: [
            'VIDAT INSTITUTO DE INTELIGENCIA MEDICA, S.L.',
            'Local 6, Carrer de Pau Muñoz i Castanyer, 12, 08174 Sant Cugat del Vallès, Barcelona.',
            'Correo electrónico de contacto: info@vidat.cat',
          ] },
        ],
      },
      {
        title: 'Finalidad del tratamiento',
        body: [
          'Los datos personales facilitados a través de los formularios de esta web serán tratados con las siguientes finalidades:',
          { type: 'list', items: [
            'Gestionar solicitudes de información sobre los servicios de VIDAT.',
            'Gestionar la incorporación a listas de espera o solicitudes de contacto.',
            'Contactar con la persona interesada por correo electrónico o teléfono.',
            'Organizar, cuando proceda, una primera visita o consulta informativa.',
            'Responder a consultas enviadas voluntariamente por la persona usuaria.',
          ] },
          'VIDAT no utilizará los datos para finalidades distintas de las indicadas sin informar previamente y, cuando sea necesario, solicitar el consentimiento correspondiente.',
        ],
      },
      {
        title: 'Datos personales tratados',
        body: [
          'A través de los formularios de la web podrán recogerse los siguientes datos:',
          { type: 'list', items: [
            'Nombre y apellidos.',
            'Correo electrónico.',
            'Teléfono.',
            'Servicio de interés.',
            'Mensaje o información facilitada voluntariamente por la persona usuaria.',
          ] },
          'Se recomienda a los usuarios no incluir información médica sensible en formularios generales de contacto. En caso de que la persona usuaria facilite voluntariamente información relacionada con su salud, dichos datos serán tratados con especial confidencialidad y únicamente para gestionar adecuadamente su solicitud.',
        ],
      },
      {
        title: 'Base jurídica del tratamiento',
        body: [
          'La base jurídica para el tratamiento de los datos es el consentimiento de la persona interesada, prestado mediante la aceptación expresa de la Política de Privacidad antes del envío del formulario.',
          'En caso de que se faciliten datos relacionados con la salud, el tratamiento se basará en el consentimiento explícito de la persona interesada y, cuando exista relación asistencial, en la prestación de servicios sanitarios.',
        ],
      },
      {
        title: 'Conservación de los datos',
        body: [
          'Los datos se conservarán durante el tiempo necesario para gestionar la solicitud de información, contacto o lista de espera.',
          'Si finalmente no se establece una relación asistencial o contractual con VIDAT, los datos podrán conservarse durante un plazo máximo de 12 meses, salvo que la persona interesada solicite antes su supresión o exista una obligación legal de conservación.',
          'Cuando exista relación asistencial, los datos se conservarán conforme a los plazos legalmente aplicables a la documentación clínica y sanitaria.',
        ],
      },
      {
        title: 'Destinatarios de los datos',
        body: [
          'Los datos no serán vendidos ni cedidos a terceros con fines comerciales.',
          'Podrán tener acceso a los datos determinados proveedores tecnológicos necesarios para el funcionamiento de la web, formularios, alojamiento, correo electrónico, agenda o gestión interna, siempre bajo las garantías legales correspondientes.',
          'También podrán comunicarse datos cuando exista una obligación legal.',
        ],
      },
      {
        title: 'Derechos de las personas interesadas',
        body: [
          'La persona interesada puede ejercer sus derechos de:',
          { type: 'list', items: [
            'Acceso.',
            'Rectificación.',
            'Supresión.',
            'Oposición.',
            'Limitación del tratamiento.',
            'Portabilidad.',
            'Retirada del consentimiento.',
          ] },
          'Para ejercer estos derechos puede escribir a: info@vidat.cat',
          'La solicitud deberá indicar claramente el derecho que se desea ejercer y permitir la identificación de la persona solicitante.',
        ],
      },
      {
        title: 'Reclamación ante la autoridad de control',
        body: [
          'Si la persona considera que el tratamiento de sus datos no se ajusta a la normativa vigente, puede presentar una reclamación ante la Agencia Española de Protección de Datos.',
        ],
      },
      {
        title: 'Seguridad y confidencialidad',
        body: [
          'VIDAT aplicará medidas técnicas y organizativas adecuadas para proteger los datos personales frente a accesos no autorizados, pérdida, alteración o divulgación indebida.',
          'El tratamiento de datos relacionados con la salud se realizará con especial confidencialidad, de acuerdo con la normativa aplicable y los principios de prudencia, minimización y seguridad.',
        ],
      },
      {
        title: 'Actualización de esta política',
        body: [
          'VIDAT podrá actualizar esta Política de Privacidad para adaptarla a cambios normativos, técnicos u organizativos. La versión vigente será la publicada en esta página.',
        ],
      },
    ]}
  />
);

export default PrivacyPolicy;
